'use strict';

import 'document-register-element';
import dispatcher from '../dispatcher';


export class MainTopVideo extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._isStopped = this.dataset.stopped === 'true';

    this.subscribe = (e) => this._subscribe(e);
  }
  connectedCallback() {
    this._video = this.querySelector('video');

    setTimeout(() => {
      this._yt = document.querySelector('#popup-video yt-video');

      this.addEventListener('click', () => {
        dispatcher.dispatch({
          type: 'popup-toggle',
          id: 'popup-video'
        });

        this._video.pause();
        this._yt.play();
      });

      dispatcher.subscribe(this.subscribe);
    }, 0)
  }
  disconnectedCallback() {
    dispatcher.unsubscribe(this.subscribe);
  }

  _subscribe(e) {
    if (e.type === 'popup-close-all') {

      this._video.play();
      this._yt.pause();
    }
  }

  on() {
    if (this._isStopped) {
      this._video.play(0);
      this._isStopped = false;
    }
  }
  off() {
    if (!this._isStopped) {
      this._video.pause();
      this._isStopped = true;
    }
  }
}


window.customElements.define('main-top-video', MainTopVideo);